import { useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { api } from '../lib/api';

/** Both CB sign-out entry points must wait for the server's confirmation. */
export function useSignOut() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const pending = useRef(false);
  const [signingOut, setSigningOut] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function signOut() {
    if (pending.current) return;
    pending.current = true;
    setSigningOut(true);
    setError(null);
    try {
      await api.auth.logout();
      queryClient.clear();
      navigate('/login', { replace: true });
    } catch {
      setError('Could not confirm sign-out. Check your connection and try again.');
    } finally {
      pending.current = false;
      setSigningOut(false);
    }
  }

  return { signOut, signingOut, error };
}
